import { type Commands } from '../../../core/context/commands';
import { UUID } from '../../../core/context/uuid/entity';
import { AttackerTypes } from './repository';
import { AttackerType } from './entity';
import { type AttackerTypeData } from './dto';

export class AttackerTypesCommands
    implements Commands<AttackerTypes, AttackerType, AttackerTypeData>
{
    addAll(repo: AttackerTypes, data: AttackerTypeData[]): AttackerTypes {
        data.forEach((attackerTypeData) => {
            this.add(repo, attackerTypeData);
        });
        return repo;
    }

    add(repo: AttackerTypes, data: AttackerTypeData): AttackerTypes {
        const attackerType = new AttackerType({
            ...data,
        });
        repo.add(attackerType);
        return repo;
    }

    update(repo: AttackerTypes, entity: AttackerType): AttackerType {
        repo.update(entity);
        return entity;
    }

    remove(repo: AttackerTypes, id: string): void {
        repo.remove(id);
    }

    create(
        repo: AttackerTypes,
        data: Omit<AttackerTypeData, 'id'>,
    ): AttackerType {
        const uuid = new UUID();
        const attackerType = new AttackerType({
            id: uuid.toString(),
            ...data,
        });
        repo.add(attackerType);
        return attackerType;
    }

    fromJSON(
        entity: AttackerType[],
        changeCallback: () => void,
    ): AttackerTypes {
        const newAttackerTypes = new AttackerTypes(changeCallback);
        entity.forEach((attackerType) => {
            newAttackerTypes.add(
                new AttackerType({
                    ...attackerType,
                }),
            );
        });
        return newAttackerTypes;
    }
}
